export default {
  "name": "NCDatePickerEnd",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCDatePickerEnd",
  "label": "时间",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "className": {
        "title": "className",
        "description": "样式",
        "type": "string"
      },
      "fieldid": {
        "title": "自动化Id",
        "description": "自动化Id",
        "type": "string"
      },
      "disabled": {
        "title": "禁用",
        "description": "禁用",
        "type": "boolean",
        "default": false
      },
      "open": {
        "title": "展开",
        "description": "展开",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}